// Module
var code = "<div class=\"gh-select\" ng-class=\"{ readonly: disabled }\"><div class=\"gh-select-toggle\" ng-click=\"show()\"><div class=\"gh-font-icon-calendar medium\" ng-if=\"!viewDate\"></div><div class=\"date-text\" ng-if=\"viewDate\">{{ viewDate }}</div></div></div>";
// Exports
module.exports = code;